module.exports = __webpack_public_path__ + "img/kruglova.d9f088c6.jpg";